import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cleanAdvisorSnippet, DBDef_AdvisorSnippet } from '@app/advisor-content-shared';
import { createWorkHubManager } from '@app/styles';
import { ModuleFE_AdvisorSnippet } from '../../../_entity/snippet/ModuleFE_AdvisorSnippet.js';
import { Editor_AdvisorSnippet } from '../../advisor-context-editor/editors/Editor_AdvisorSnippet.js';
import './Manager_AdvisorSnippet.scss';
import { LL_V_L } from "@nu-art/thunderstorm-frontend/index";
import { Renderer_AdvisorSnippetHeader } from "./renderers/Renderer_AdvisorSnippetHeader/Renderer_AdvisorSnippetHeader.js";
const Editor_AdvisorSnippet_Wrapper = (props) => _jsxs(LL_V_L, { className: 'manager-advisor-snippet', children: [_jsx(Renderer_AdvisorSnippetHeader, { workHubItem: props.workHubItem, renderArgs: props.renderArgs }), _jsx(Editor_AdvisorSnippet, { editable: props.editable, editMode: props.renderArgs.editMode, hideHeader: true })] });
export const Manager_AdvisorSnippet = createWorkHubManager({
    module: ModuleFE_AdvisorSnippet,
    dbDef: DBDef_AdvisorSnippet,
    defaultItem: cleanAdvisorSnippet,
    labelResolver: (snippet) => snippet.label ?? "New Snippet",
    EditorComponent: Editor_AdvisorSnippet_Wrapper,
});
//# sourceMappingURL=Manager_AdvisorSnippet.js.map